import { OnboardingApiClient } from '@fourthwall/services/dist/OnboardingApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOnboardingSummaryQuery = createQueryHook(OnboardingApiClient.getSummary, {
  queryKey: ['onboardingSummary'],
})
